// The environment page: its action, facts, limits, workspaces, network and egress.
import { plural } from "../../../helpers";

const p = plural("en");

export default {
  couldNotLoad: "Could not load environment",
  shell: {
    open: "Open terminal",
    banner: "Root shell in your environment. Anything you run here affects your agents' environment. Sessions are recorded (not what you type).",
    keep: "Set up your VPN here and enable its service (systemctl enable …) so it comes back when the environment restarts. An environment idle for an hour is deleted, and what you installed goes with it.",
    unlinked: "The terminal runs over this browser's device connection: link this browser first.",
    linkDevices: "Go to Devices",
    label: (id: string) => `root shell · environment ${id}`,
    loading: "Loading terminal…",
  },
  actions: { stop: "Stop", start: "Start", retry: "Retry" },
  changed: (status: string) => `Environment ${status}`,
  facts: "Environment facts",
  instance: "Instance",
  baseImage: "Base image",
  workerImage: "Worker image",
  docker: "Docker",
  proxiedSocket: "Proxied socket",
  notSetUp: "Not set up yet",
  runs: "Runs",
  created: "Created",
  quotaShare: "Share of the organisation's quota",
  limits: {
    title: "Limits",
    description: "Enforced by Incus on the whole environment",
    cpu: "CPU",
    memory: "Memory",
    cpuDetail: (org: string) => `Of ${org}'s quota; workers share the environment's cores`,
    memoryDetail: (org: string) => `Of ${org}'s quota`,
  },
  workspaces: {
    title: "Workspaces",
    description: "Repositories and agent state that persist across runs",
    emptyTitle: "No workspaces yet",
    emptyBody: "A workspace holds repositories on a persistent volume, and the long-lived worker you open a terminal into.",
  },
  network: {
    title: "Network",
    description: "Own namespace on the host bridge",
    vpn: "VPN",
    noVpn: "None. A WireGuard or OpenVPN profile reaches a private network; it runs inside this environment only.",
    profile: (type: string, required: boolean) => `${type} profile${required ? ", required: workers do not start without it" : ""}.`,
    routes: "Routes",
    dns: "DNS",
    egress: "Egress",
    egressBody: "Allowlist only, through the worker proxy. No direct DNS.",
    overlap: "Overlapping private ranges between orgs are fine: each VPN lives in its own namespace.",
  },
  egress: {
    title: "Egress allowlist",
    description: (n: number) => p(n, { one: "# domain workers may reach; everything else is refused", other: "# domains workers may reach; everything else is refused" }),
    nothing: "Nothing: workers cannot reach the internet.",
  },
};
